import { MINIMUM_TIMEOUT, NO_TIMEOUT } from 'constants/timers';

const idleTimeout = (): number | undefined => {
  const timeout = window.xprops?.idleTimeout || NO_TIMEOUT;

  if (timeout > 0 && timeout < MINIMUM_TIMEOUT) {
    return MINIMUM_TIMEOUT;
  }

  return timeout;
};

export { idleTimeout };
